import script from "./SignUp.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUp.vue?vue&type=script&setup=true&lang=js"

import "./SignUp.vue?vue&type=style&index=0&id=46c39d02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46c39d02"]])

export default __exports__